














import { defineComponent, PropType } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import { GetVSAInventoryFlowTypesItem } from '../consts';
import { VSAInventoryFlowTypesItem } from '../types';

const name = 'ttam-placement-type-vsa-auto';

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    flowTypeItem: {
      type: Object as PropType<VSAInventoryFlowTypesItem>,
      default: GetVSAInventoryFlowTypesItem(),
    },
  },
  setup() {
    return {
      name,
    };
  },
});
